var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.8V17.6L15 13.2L8 8.8ZM20 4.4H12.42L15.71 0.781L15 0L11 4.4H10.97L6.97 0L6.28 0.781L9.56 4.4H2C0.9 4.4 0 5.39 0 6.6V19.8C0 21.01 0.9 22 2 22H20C21.1 22 22 21.01 22 19.8V6.6C22 5.39 21.1 4.4 20 4.4ZM20 19.8H2V6.6H20V19.8Z",
    fill: "#FAAF3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.24a10881076af6f248dd2431c53227d1.svg";
export { ForwardRef as ReactComponent };